import scss from './tooltipMarkup.module.scss';

const createTooltipMarkup = ({ tooltipModel, averages, isFiltersApplied }) => {
  if (!tooltipModel) {
    return '';
  }

  const dataPoint = tooltipModel.dataPoints[0];
  const title = tooltipModel.title[0];
  const dataIndex = dataPoint.dataIndex;
  const totalAverage = averages[dataIndex]?.value;

  const color = dataPoint.dataset.backgroundColor[dataPoint.dataIndex % dataPoint.dataset.backgroundColor.length];

  const calculations = [
    {
      label: title,
      value: dataPoint.raw,
      color: color,
    },
    ...(isFiltersApplied
      ? [
          {
            label: 'Global',
            value: totalAverage,
            color: '#fdbf47',
          },
        ]
      : []),
  ];

  return `
    <div class='${scss.outerBox}'>
      <div class='${scss.title}'>
       ${title}
      </div>
      <div class='${scss.infoBlock}'>
         ${calculations.map(createRecord).join('\n')} 
      </div>
    </div>
  `;
};

export default createTooltipMarkup;

const createRecord = ({ label, value, color }) => {
  return `
    <div class='${scss.record}'>
     ${color ? `<div class="${scss.marker}" style="background-color: ${color}"></div>` : ''}
      <span class='${scss.label}'>${label}:</span>
      <span class='${scss.value}'>${value}%</span>
    </div>
  `;
};
